module.exports = __webpack_public_path__ + "img/fuka2.25caf148.png";